import { AppBar, Toolbar, useTheme } from "@mui/material";
import { HeaderPc } from "./components/HeaderPc";
import { useState } from "react";
import { HeaderMb } from "./components/HeaderMb";
import { DrawerMenuMb } from "./components/DrawerMenuMb";
import { useLocation } from "react-router-dom";

export const Header = () => {
  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(false);
   const location = useLocation();
  const onDrawer = (newOpen: boolean) => () => {
    setOpenDrawer(newOpen);
  };

  return (
    <>
      {location.pathname === "/search" ? (
        <></>
      ) : (
        <AppBar
          elevation={0}
          sx={{
            position: "sticky",
            paddingRight: "0px !important",
            top: 0,
            backgroundColor: theme.palette.background.paper,
            backdropFilter: "saturate(180%) blur(20px)",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 60,
            }}
          >
            <HeaderPc />
            <HeaderMb onClick={onDrawer(true)} />
            <DrawerMenuMb open={openDrawer} onClose={onDrawer(false)} />
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};
